import '@ant-design/compatible/assets/index.css';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import PartnerAccount from './list';

@withTranslation()
class PartnerAccountPage extends React.Component {
  constructor() {
    super();

    this.state = {};
  }

  render() {
    return <PartnerAccount />;
  }
}

export default PartnerAccountPage;

PartnerAccountPage.propTypes = {
  t: PropTypes.func,
  history: PropTypes.object,
  auth: PropTypes.shape({
    currentRoleSlug: PropTypes.string,
  }),
  cmsUser: PropTypes.object,
};

PartnerAccountPage.defaultProps = {
  t: () => {},
  history: '',
  auth: {},
  cmsUser: {},
};
